module.exports = __webpack_public_path__ + "transpPhonetique_24x24.png?29b79c2a50ee09fc4de930f7176c4ae5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/transpPhonetique_24x24.png
// module id = 1039
// module chunks = 0